import React from 'react'
import DeviceForm from '../../Forms/DeviceForm'

const DeleteDevices = () => <DeviceForm isDelete />

export default DeleteDevices
